import type { GameRunStats } from '../../../domain/gameplay/GameRunStats';
import type { SubmitScorePayload } from '../models/submit-score-payload';

export const createSubmitScorePayload = (
  run: GameRunStats,
  nickname: string,
  clientVersion?: string,
): SubmitScorePayload => {
  if (!run.sessionId || run.finishedAt === null) {
    throw new Error('Cannot submit an unfinished game run.');
  }
  return {
    nickname,
    score: run.score,
    sessionId: run.sessionId,
    startedAt: run.startedAt,
    finishedAt: run.finishedAt,
    meteorsPassed: run.meteorsPassed,
    meteorsDestroyed: run.meteorsDestroyed,
    shotsFired: run.shotsFired,
    ammoBonusesCollected: run.ammoBonusesCollected,
    lifeBonusesCollected: run.lifeBonusesCollected,
    clientVersion,
  };
};
